import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AuthUser } from 'Types'

export const initialState: AuthUser | null = null

const userSlice = createSlice({
 name: 'user',
 initialState: initialState as AuthUser | null,
 reducers: {
 setUserAction: {
 reducer: (_state: AuthUser | null, action: PayloadAction<AuthUser>) => {
 return action.payload
 },
 prepare: (payload: AuthUser) => ({ payload })
 },
 removeUserAction: (_state: AuthUser | null) => {
 return null
 }
 }
})

export const { setUserAction, removeUserAction } = userSlice.actions
export default userSlice.reducer
